export default __webpack_public_path__ + "static/media/2.58571d8b.jpg";